import angular from 'angular';

const nodeExecMethodDirective = /* @ngInject */ (
	/** @type {import('angular').ITimeoutService} */ $timeout,
	/** @type {any} */ UIActionService,
	/** @type {any} */ User,
) => ({
	restrict: 'A',
	scope:    {
		nodeExecMethod: '=',
		nodeKid:        '=?',
		key:            '=?',
		data:           '=?',
		events:         '=?',
	},
	require: '^^?mf',
	link:     (
		/** @type {any} */ scope,
		/** @type {any} */ element,
		/** @type {any} */ _attributes,
		/** @type {import('~/components/mf/mf.controller').default | undefined} */ mfCtrl,
	) => {
		const methodKid = scope.nodeExecMethod ? scope.nodeExecMethod.kid : undefined;
		if (scope.nodeExecMethod && 'kjson' in scope.nodeExecMethod) {
			scope.events = scope.nodeExecMethod.kjson.front.events;
		}

		if (Object.keys(scope.events).length > 0) {
			element.prop('disabled', true);
			Object.entries(scope.events).map(([event, m]) => {
				element.bind(event, async () => {
					try {
						const t = await UIActionService.action(m.action, m.params, methodKid, scope.nodeKid, scope.data, null);
						element.prop('disabled', false);
						if (t?.action === 'updateCurrentValue' && scope.key) {
							for (const [k, value] of Object.entries(t.params?.value || t.value)) {
								if (value.kid === '0') {
									t.value[k].kid = `K_NODE;${User.getRefNr()}`;
									if (mfCtrl) {
										mfCtrl.select({
											isa:     mfCtrl.options?.createKid || mfCtrl.order,
											kid:     '__create',
											name:    t.value[k].name,
											new_kid: t.value[k].kid,
											orphan:  mfCtrl.lastForm,
										}, null);
										$timeout(() => {
											mfCtrl.ngModelCtrl?.$validate();
										});
									}
								}
							}
							if (scope.data) {
								$timeout(() => {
									scope.data[scope.key] = t.value;
								});
							}
						}
						else if (t?.action === 'updateFormData') {
							for (const [key, data] of Object.entries(t.data)) {
								if (Array.isArray(data)) {
									for (const [k, v] of Object.entries(data)) {
										if (k === 'kid' && v === '0') {
											t.data[key][k] = `K_NODE;${User.getRefNr()}`;
										}
									}
								}
							}
							scope.data = t.data;
						}
					}
					catch (error) {
						console.error(error);
					}
				});
				return [event, m];
			});
		}
	},
});

angular.module('app')
	.directive('nodeExecMethod', nodeExecMethodDirective);
